import React from "react";

function Carrinho() {
  return (
    <div className="container">
      <h2>Meu Carrinho</h2>
      <p>Lista de senhas adicionadas ao carrinho.</p>
    </div>
  );
}

export default Carrinho;
